import React, { Component } from "react";
import { Container,Col ,Row,UncontrolledDropdown ,DropdownToggle,DropdownMenu,Form, DropdownItem, Input, FormGroup, Label} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Calender from '../calender';
import {connect } from 'react-redux';
import { 
    faAngleDown,
   faMapMarkerAlt, faSearch,
 } from '@fortawesome/free-solid-svg-icons'
 import { withRouter } from "react-router-dom";
 import 'bootstrap'


class AdvencedSearchVisas extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }
  state = {
    advancedSearch: {
      destination: "",
      startDate: "",
      endDate: "",
      nbrChambres: 1,
      nbrEnfant: 1,
      nbrAdultes: 1,
    },
    clikedDetailInput: false,
  };

  onInputChange(evt) {
    this.setState({
      advancedSearch: {
        ...this.state.advancedSearch,
        [evt.target.name]: evt.target.value,
      },
    });
  }
  

  onFormSubmit(evt) {
    evt.preventDefault();
    this.props.dispatch({
      type: "ADVANCED_SEARCH",
      payload: this.state.advancedSearch,
    });
    this.props.history.push("/visas/advanced_search");
  }
  render() {
    const { nbrChambres, nbrEnfant, nbrAdultes } = this.state.advancedSearch;
    return (
      <>
        <Container>
          <Row className="d-flex justify-contnet-between px-2">
              <div className="destination-input phone-view-first mb-0 mb-lg-3 col-12 col-sm-6 col-lg-4  px-1 pl-lg-2">
                <UncontrolledDropdown nav inNavbar>
                  <input type="text" className="filter-element" placeholder=" Votre Destination"/>
                    <Row>
                      <DropdownMenu  className="destination-drop-down">
                        <div>
                          <input type="text" name="destination" className="input-destination" placeholder="Rechercher un Pays/Ville.."/>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block">
                            <div className="result-search">
                              <FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>
                              Skikda,Algérie</div>
                            <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Oran,Algérie</div>
                            <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Relizane,Algérie</div>
                            </div>
                            <span id="recent-title">Récents</span>
                             <hr />
                             <div className="result-block">
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} />Skikda,Algérie</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} />Ibiza,Espagne</div>
                             <div className="recent"><FontAwesomeIcon  icon={faSearch} />Dubai,UAE</div>
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                    </Row>
                  </UncontrolledDropdown>
              </div>

                <div className="col-12 col-sm-6 col-lg-3 mb-0 mb-lg-3 px-1">
                <UncontrolledDropdown nav inNavbar>
                <DropdownToggle id="destination" className="Advanced-btn-ser filter-element">
                      Retour Prévu
                      <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                    </DropdownToggle>
                    <DropdownMenu left className="detail-drop-down">
                     <span className="label-detail-search">Adultes <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrAdultes" value={nbrAdultes}/></span></span>
                     <span className="label-detail-search">Enfant  <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrEnfant" value={nbrEnfant}/></span></span>
                     <span className="label-detail-search">Chambres <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrChambres" value={nbrChambres}/></span></span>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                
                <div className="col-12 col-sm-6 col-lg-3 mb-0 mb-md-3 px-1">
                <UncontrolledDropdown nav inNavbar>
                <DropdownToggle id="destination" className="Advanced-btn-ser filter-element">
                      Retour Prévu
                      <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                    </DropdownToggle>
                    <DropdownMenu left className="detail-drop-down">
                     <span className="label-detail-search">Adultes <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrAdultes" value={nbrAdultes}/></span></span>
                     <span className="label-detail-search">Enfant  <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrEnfant" value={nbrEnfant}/></span></span>
                     <span className="label-detail-search">Chambres <span><input className="detail-input" min="1" defaultValue = "1" type="number" name="nbrChambres" value={nbrChambres}/></span></span>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>

                <div className="destination-input col-12 col-sm-6 col-lg-2 mb-0 mb-lg-3 px-1">
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle id="recherche-button" className="filter-element-search" onClick={this.onFormSubmit.bind(this)}>
                      Recherche
                      <img src="/imgs/navebar/search.svg" alt="" id="recherche"/>

                    </DropdownToggle>
                  </UncontrolledDropdown>
                </div>
          </Row>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    // startDate: state.counterApp.startDate,
    // endDate: state.counterApp.endDate,
  }
}
//connect function INJECTS dispatch function as a prop!!
// export default connect(mapStateToProps)(AdvencedSearchGhurfaty);
export default withRouter(connect(mapStateToProps)(AdvencedSearchVisas));
